const Notice = {

    // PAGE HEADER
    "notice": "Notice",

    // FIELDS
    "premise": "Premise",
    "title": "Title",
    "start_date": "Publish Start Date",
    "end_date": "Publish End Date",
    "notice_type": "Notice Type",
    "description": "Description",
    "attachments": "Attachments",
    "target_group": "Target Group",
    "zone": "Zone",
    "level": "Level",
    "unit": "Unit",
    "search": "Search",
    "created_at": "Created At",
    "view": "View",

    // TABLE HEADERS
    "table_premise": "PREMISE",
    "table_title": "TITLE",
    "table_type": "TYPE",
    "table_start_date": "START DATE",
    "table_end_date": "END DATE",

    // ERROR
    "error_premise": "Select Premise",
    "error_title": "Enter Title",
    "error_notice_type": "Select Notice Type",
    "error_start_date": "Select Start Date",
    "error_end_date": "Select End Date",
    "error_description": "Enter Description",

}

export default Notice;